import React from 'react';
import './css/estimate.css';
import homewindowLogo from '../image/homewindow_logo.png';
import homewindowLogoWhite from './image/homewindow.png';
import kccLogoWhite from './image/kcchomeCC.png';
import lxhausysLogoWhite from './image/lxhausys.png';

interface EstimatePreviewProps {
  estimateData: any;
}

const EstimatePreviewReadOnly: React.FC<EstimatePreviewProps> = ({ estimateData }) => {
  if (!estimateData) {
    return <div>견적서 데이터를 불러올 수 없습니다.</div>;
  }

  // 데이터 구조 확인 및 처리
  console.log('EstimatePreviewReadOnly - estimateData:', estimateData);
  console.log('EstimatePreviewReadOnly - estimateData.items:', estimateData.items);
  
  // checkboxes 상태 복원
  let checkboxes = { homeWindow: true, lxHausys: true, kccHomeCC: true }; // 기본값
  if (estimateData.checkboxes) {
    try {
      checkboxes = JSON.parse(estimateData.checkboxes);
      console.log('EstimatePreviewReadOnly - checkboxes 복원:', checkboxes);
    } catch (error) {
      console.error('checkboxes 파싱 오류:', error);
    }
  }

  // selectedGrades 상태 복원
  let selectedGrades = { LX: '프리미엄', 홈윈도우: '프리미엄' };
  if (estimateData.selectedGrades) {
    try {
      const parsed = JSON.parse(estimateData.selectedGrades);
      selectedGrades = {
        LX: parsed.LX || '프리미엄',
        홈윈도우: parsed.홈윈도우 || '프리미엄',
      };
    } catch (error) {
      console.error('selectedGrades 파싱 오류:', error);
    }
  }

  // items 배열에서 데이터 추출 (실제 데이터베이스 구조)
  const items = estimateData.items || [];
  console.log('EstimatePreviewReadOnly - items length:', items.length);

  // 샷시 항목 필터링 (실제 데이터 구조에 맞게)
  const chassisItems = items.filter((item: any) => 
    item.productType === '샷시&망&랩핑'
  );
  console.log('EstimatePreviewReadOnly - chassisItems:', chassisItems);
  
  // 중문&기타 항목 필터링
  const otherItems = items.filter((item: any) => 
    item.productType === '중문&기타'
  );
  console.log('EstimatePreviewReadOnly - otherItems:', otherItems);
  
  // 통바 항목 필터링
  const tongbaItems = items.filter((item: any) => 
    item.productType === '통바'
  );
  console.log('EstimatePreviewReadOnly - tongbaItems:', tongbaItems);

  // 실제 데이터 구조 확인
  console.log('EstimatePreviewReadOnly - 첫 번째 아이템:', items[0]);
  console.log('EstimatePreviewReadOnly - 모든 아이템의 productType:', items.map(item => item.productType));
    console.log('EstimatePreviewReadOnly - 샷시 아이템의 브랜드별 가격:', chassisItems.map(item => ({
      id: item.id,
      item: item.item,
      width: item.width,
      height: item.height,
      brand: item.brand,
      price: item.price,
      priceWithTax: item.priceWithTax,
      note: item.note,
      installLocation: item.installLocation
    })));
    
    // 실제 견적서에서 어떻게 표시되는지 확인하기 위한 로그
    console.log('EstimatePreviewReadOnly - 원본 아이템들 (그룹화 전):', chassisItems.map(item => ({
      id: item.id,
      item: item.item,
      width: item.width,
      height: item.height,
      brand: item.brand,
      price: item.price,
      installLocation: item.installLocation
    })));
  console.log('EstimatePreviewReadOnly - 통바 아이템:', tongbaItems.map(item => ({
    item: item.item,
    spec: item.spec,
    length: item.length,
    width: item.width,
    height: item.height,
    note: item.note,
    quantity: item.quantity,
    price: item.price,
    priceWithTax: item.priceWithTax
  })));
  console.log('EstimatePreviewReadOnly - 중문&기타 아이템:', otherItems.map(item => ({
    item: item.item,
    width: item.width,
    height: item.height,
    spec: item.spec,
    note: item.note,
    quantity: item.quantity,
    price: item.price,
    priceWithTax: item.priceWithTax
  })));
  
  // 추가사항 항목 필터링
  const additionalItems = items.filter((item: any) => 
    item.productType === '추가사항'
  );
  console.log('EstimatePreviewReadOnly - additionalItems:', additionalItems);
  
  // 할인 항목 필터링
  const discountItems = items.filter((item: any) => 
    item.productType === '할인내역'
  );
  console.log('EstimatePreviewReadOnly - discountItems:', discountItems.map(item => ({
    id: item.id,
    item: item.item,
    price: item.price,
    priceWithTax: item.priceWithTax,
    quantity: item.quantity,
    note: item.note
  })));
  
  // 브랜드별 항목 그룹화
  const itemsByBrand: { [key: string]: any[] } = {};
  chassisItems.forEach((item: any) => {
    if (!itemsByBrand[item.brand]) {
      itemsByBrand[item.brand] = [];
    }
    itemsByBrand[item.brand].push(item);
  });
  console.log('EstimatePreviewReadOnly - itemsByBrand:', itemsByBrand);

  // 브랜드별 합계 계산
  const brandTotals: { [key: string]: number } = {};
  Object.keys(itemsByBrand).forEach(brand => {
    brandTotals[brand] = itemsByBrand[brand].reduce((sum, item) => 
      sum + (item.priceWithTax || 0), 0
    );
  });

  // 중문&기타 합계
  const otherTotal = otherItems.reduce((sum: number, item: any) => 
    sum + (item.priceWithTax || 0), 0
  );

  // 통바 합계
  const tongbaTotal = tongbaItems.reduce((sum: number, item: any) => 
    sum + (item.priceWithTax || 0), 0
  );

  // 추가사항 합계
  const additionalTotal = additionalItems.reduce((sum: number, item: any) => 
    sum + (item.priceWithTax || 0), 0
  );

  // 할인 합계
  const discountTotal = discountItems.reduce((sum: number, item: any) => 
    sum + (item.priceWithTax || 0), 0
  );

  // 전체 합계
  const totalAmount = Object.values(brandTotals).reduce((sum, val) => sum + val, 0) 
    + otherTotal + tongbaTotal + additionalTotal + discountTotal;

  return (
    <div id="estimate-form" className="container preview-mode">
      <div className="estimate-header">
        <div style={{ width: '100%' }}>
          <div style={{ textAlign: 'left' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <img
                src={homewindowLogo}
                alt="Home Window"
                className="estimate-logoImg"
                style={{ width: '200px', marginBottom: '0' }}
              />
            </div>
            <h1 className="estimate-title">견적서</h1>
          </div>
        </div>
      </div>

      {/* 견적정보 & 고객정보 */}
      <div className="section-group">
        <div style={{ display: 'flex', gap: '20px' }}>
          {/* 견적정보 */}
          <div style={{ width: '60%' }}>
            <div className="section-title section-title-no-margin">견적정보</div>
            <table className="table2" style={{ width: '100%', marginBottom: '0' }}>
              <tbody>
                <tr>
                  <th style={{ width: '35%' }}>견적번호</th>
                  <th style={{ width: '23%' }}>견적일자</th>
                  <th style={{ width: '15%' }}>견적자명</th>
                  <th style={{ width: '27%' }}>견적유형</th>
                </tr>
                <tr>
                  <td>
                    <input
                      type="text"
                      value={estimateData.estimateNumber || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={(estimateData.estimateDate || '').replace(/-/g, '.')}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td className="position-relative">
                    <input
                      type="text"
                      value={estimateData.estimator || ''}
                      readOnly
                      className="bg-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={estimateData.estimateType || '현장실측 견적'}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* 시공정보 */}
          <div style={{ width: '36%' }}>
            <div className="section-title section-title-no-margin">시공정보</div>
            <table className="table2" style={{ width: '100%', marginBottom: '0' }}>
              <tbody>
                <tr>
                  <th style={{ width: '35%' }}>시공유무</th>
                  <th style={{ width: '65%' }}>시공희망일</th>
                </tr>
                <tr>
                  <td>
                    <input
                      type="text"
                      value={estimateData.constructionStatus || '시공'}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={estimateData.scheduledDate || '미정'}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 고객정보 & 주소 (다음 줄) */}
      <div className="section-group">
        <div className="section-title section-title-no-margin">고객정보</div>
        <table className="table2" style={{ width: '100%', marginBottom: '0' }}>
          <tbody>
            <tr>
              <th style={{ width: '15%' }}>고객명</th>
              <th style={{ width: '20%' }}>연락처</th>
              <th style={{ width: '65%' }}>주소</th>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  value={estimateData.customerName || ''}
                  readOnly
                  className="bg-light-gray"
                />
              </td>
              <td>
                <input
                  type="tel"
                  value={estimateData.phone || ''}
                  readOnly
                  className="bg-light-gray"
                />
              </td>
              <td>
                <div style={{ display: 'flex', gap: '5px' }}>
                  <input
                    type="text"
                    value={estimateData.address || ''}
                    readOnly
                    className="bg-light-gray"
                    style={{ flex: '1' }}
                    placeholder="기본주소 입력"
                  />
                  <input
                    type="text"
                    value={estimateData.detailedAddress || ''}
                    readOnly
                    className="bg-light-gray"
                    style={{ width: '150px' }}
                    placeholder="상세주소 입력"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 견적합계 섹션 */}
      <div className="section-title section-title-main">견적합계</div>
      <div className="estimate-summary-cards">
        {[
          {
            key: 'lxHausys',
            label: 'LX하우시스',
            color: '#b72c2c',
            headerColor: '#b72c2c',
            logo: lxhausysLogoWhite,
          },
          {
            key: 'homeWindow',
            label: '홈윈도우',
            color: '#333',
            headerColor: '#333',
            logo: homewindowLogoWhite,
          },
          {
            key: 'kccHomeCC',
            label: 'KCC홈씨씨',
            color: '#0056b8',
            headerColor: '#0056b8',
            logo: kccLogoWhite,
          },
        ].map((brand) => {
          // 브랜드 코드 매핑: HW -> homeWindow, LX -> lxHausys, KC -> kccHomeCC
          const brandCode = brand.key === 'homeWindow' ? 'HW' : 
                           brand.key === 'lxHausys' ? 'LX' : 'KC';
          
          // 브랜드별 합계 계산 (실제 데이터에서)
          let brandTotal = 0;
          const brandItems = chassisItems.filter((item: any) => item.brand === brandCode);
          console.log(`${brand.label} 브랜드 아이템들:`, brandItems.map(item => ({
            id: item.id,
            item: item.item,
            price: item.price,
            priceWithTax: item.priceWithTax,
            brand: item.brand
          })));
          
          // ReactEstimateForm.tsx와 동일한 계산 로직 적용
          
          // 1. 브랜드별 샷시 금액 합산
          let brandShasiSum = 0;
          brandItems.forEach((item: any) => {
            if (item.price) {
              brandShasiSum += parseFloat(item.price) || 0;
            }
          });
          
          // 2. 추가사항, 통바, 중문 등 기타 금액 합산 (비공개 금액 제외)
          // ReactEstimateForm.tsx와 동일하게 price 필드 사용
          const otherSum = otherItems
            .filter((item: any) => item.item && item.item !== '-')
            .reduce((sum: number, item: any) => sum + (parseFloat(item.price) || 0), 0);

          const tongbaSum = tongbaItems
            .filter((item: any) => item.item && item.item !== '-')
            .reduce((sum: number, item: any) => sum + (parseFloat(item.price) || 0), 0);

          const additionalSum = additionalItems
            .filter((item: any) =>
              item.item && item.item !== '-' && item.item !== '직접입력(고객 비공개용)' && item.item !== '비공개 금액_선택' && item.item !== '비공개 금액_주택' && item.item !== '비공개 금액_빌라'
            )
            .reduce((sum: number, item: any) => {
              // 직접입력 항목도 수량 곱하지 않고 price 그대로 사용
              // if (item.item === '직접입력') {
              //   const quantity = parseFloat(item.quantity);
              //   // 수량이 없거나 0이면 0원, 있으면 단가 × 수량
              //   if (!quantity || isNaN(quantity) || quantity <= 0) {
              //     return sum;
              //   }
              //   return sum + ((parseFloat(item.price) || 0) * quantity);
              // }
              // 모든 항목 price 그대로 사용
              return sum + (parseFloat(item.price) || 0);
            }, 0);

          // 3. 전체 기타 금액
          const etcTotal = otherSum + tongbaSum + additionalSum;
          
          // 4. 통바와 추가사항 금액 (할인 제외 대상)
          const excludedFromDiscount = tongbaSum + additionalSum;

          // 5. 공급가 총 합계 - calculateTotals와 동일
          const supplyPrice = brandShasiSum + etcTotal;
          
          // 6. 할인 금액 계산 (배지 표시용)
          let discountAmount = 0;
          
          // 할인내역에서 해당 브랜드의 할인 정보 찾기
          const brandDiscountItem = discountItems.find((item: any) => item.brand === brandCode);
          if (brandDiscountItem && brandDiscountItem.priceWithTax) {
            discountAmount = Math.abs(parseFloat(brandDiscountItem.priceWithTax)) || 0;
          }

          // 7. 최종 견적가 = 샷시(할인 적용됨)*1.1 + 중문&기타*1.1 + 통바/추가사항*1.1 — calculateTotals와 동일
          const finalAmount = Math.round(brandShasiSum * 1.1) + Math.round(otherSum * 1.1) + Math.round(excludedFromDiscount * 1.1);
          
          // 디버깅용 로그
          console.log(`${brand.label} 브랜드 계산:`, {
            brandCode, brandShasiSum, otherSum, excludedFromDiscount, supplyPrice, discountAmount, finalAmount
          });

          // 체크박스 상태에 따라 활성/비활성 클래스 결정
          const isActive = brand.key === 'homeWindow' ? checkboxes.homeWindow :
                          brand.key === 'lxHausys' ? checkboxes.lxHausys :
                          brand.key === 'kccHomeCC' ? checkboxes.kccHomeCC : false;

          return (
            <div
              key={brand.key}
              className={`summary-card ${isActive ? 'summary-card-active' : 'summary-card-inactive'}`}
              style={{ 
                border: `3px solid ${brand.headerColor}`,
                borderRadius: '8px'
              }}>
              {/* 상단 헤더 */}
              <div
                className="summary-card-header"
                style={{ background: brand.headerColor }}>
                <img
                  src={brand.logo}
                  alt={brand.label}
                  className={`summary-card-logo ${
                    brand.key === 'homeWindow'
                      ? 'summary-card-logo-homeWindow'
                      : 'summary-card-logo-other'
                  }`}
                />
              </div>

              {/* 카드 내용 — 견적서(PricingSummaryCards)와 동일한 순서 */}
              <div className="summary-card-body">
                {/* 등급 표시 */}
                <div className="selected-grade-display">
                  {brand.key === 'lxHausys' && (
                    <span>{selectedGrades.LX === '프리미엄' ? 'PREMIUM' : selectedGrades.LX === '스탠다드' ? 'STANDARD' : 'BASIC'} 등급</span>
                  )}
                  {brand.key === 'homeWindow' && (
                    <span>{selectedGrades.홈윈도우 === '프리미엄' ? 'PREMIUM' : selectedGrades.홈윈도우 === '스탠다드' ? 'STANDARD' : 'BASIC'} 등급</span>
                  )}
                  {brand.key === 'kccHomeCC' && (
                    <span>ONE 등급</span>
                  )}
                </div>
                {/* 할인/정상가 배지 */}
                <div className="discount-badge">
                  {discountAmount > 0 ? (() => {
                    const discountItem = discountItems.find((item: any) => item.brand === brandCode);
                    if (discountItem) {
                      const rateMatch = discountItem.item?.match(/(\d+)%/);
                      return rateMatch ? `샤시 ${rateMatch[1]}% 할인 적용` : discountItem.item;
                    }
                    return '할인 적용';
                  })() : '정상가'}
                </div>
                {/* 공급가 */}
                <div className="price-row">
                  <span className="price-label">공급가</span>
                  <span className="price-value">
                    {supplyPrice.toLocaleString()} 원
                  </span>
                </div>
                {/* 부가세 */}
                <div className="price-row">
                  <span className="price-label">부가세</span>
                  <span className="price-value-gray">
                    {(Math.round(supplyPrice * 1.1) - supplyPrice).toLocaleString()} 원
                  </span>
                </div>
                {/* 구분선 */}
                <hr className="divider" />
                {/* 최종 견적가 */}
                <div className="price-row-total">
                  <span className="total-label">최종 견적가</span>
                  <span className="price-value-large">
                    {finalAmount.toLocaleString()} 원
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* 샷시 & 망 & 랩핑 섹션 */}
      {chassisItems.length > 0 && (
        <>
          <div className="section-title section-title-main shasi">
            샷시 & 망 & 랩핑
          </div>
          
          <table className="table" id="shasiTable">
            <tbody>
              <tr>
                <th className="col-1">NO</th>
                <th className="col-10">설치위치</th>
                <th className="col-20">품명</th>
                <th className="col-13">규격(W x H)</th>
                <th className="col-5">수량</th>
                <th className="col-13">LX하우시스</th>
                <th className="col-13">홈윈도우</th>
                <th className="col-13">KCC홈씨씨</th>
                <th className="col-10">비고</th>
              </tr>
              {(() => {
                // 아이템을 그룹화하기 위한 임시 객체
                // note 필드에서 __IDX로 원본 행 인덱스를 추출
                const rowGroups: { [key: string]: any } = {};
                
                chassisItems.forEach((item: any) => {
                  // note에서 원본 행 인덱스 추출 (예: "메모__IDX0" -> 0)
                  let rowIndex = '0';
                  if (item.note) {
                    const match = item.note.match(/__IDX(\d+)/);
                    if (match) {
                      rowIndex = match[1];
                    }
                  }
                  
                  // 행 인덱스를 키로 사용하여 그룹화
                  if (!rowGroups[rowIndex]) {
                    rowGroups[rowIndex] = {
                      installLocation: item.installLocation || '',
                      item: item.item || '',
                      width: item.width || '',
                      height: item.height || '',
                      quantity: item.quantity || '',
                      lxHausysPrice: 0,
                      homeWindowPrice: 0,
                      kccHomeCCPrice: 0,
                      note: item.note ? item.note.replace(/__IDX\d+/, '').trim() : ''
                    };
                  }
                  
                  // 해당 브랜드의 가격 설정
                  const row = rowGroups[rowIndex];
                  
                  // 같은 행의 다른 속성들도 업데이트 (브랜드별로 다를 수 있음)
                  if (!row.installLocation && item.installLocation) {
                    row.installLocation = item.installLocation;
                  }
                  if (!row.item && item.item) {
                    row.item = item.item;
                  }
                  if (!row.width && item.width) {
                    row.width = item.width;
                  }
                  if (!row.height && item.height) {
                    row.height = item.height;
                  }
                  
                  // 브랜드별 가격 설정
                  if (item.brand === 'LX' && item.price) {
                    row.lxHausysPrice = parseFloat(item.price);
                  } else if (item.brand === 'HW' && item.price) {
                    row.homeWindowPrice = parseFloat(item.price);
                  } else if (item.brand === 'KC' && item.price) {
                    row.kccHomeCCPrice = parseFloat(item.price);
                  }
                });
                
                // 인덱스 순서대로 정렬하여 배열로 변환
                const processedItems = Object.keys(rowGroups)
                  .sort((a, b) => parseInt(a) - parseInt(b))
                  .map(key => rowGroups[key]);
                
                console.log('EstimatePreviewReadOnly - 원본 chassisItems:', chassisItems);
                console.log('EstimatePreviewReadOnly - 원본 chassisItems 개수:', chassisItems.length);
                console.log('EstimatePreviewReadOnly - 고유한 행 개수:', processedItems.length);
                console.log('EstimatePreviewReadOnly - 처리된 아이템들:', processedItems);
                
                return processedItems.map((item: any, index: number) => (
                  <tr key={`${item.item}_${index}`}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        type="text"
                        value={item.installLocation}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.item}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={`${item.width} x ${item.height}`}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.quantity || ''}
                        readOnly
                        className="bg-light-gray"
                        style={{ textAlign: 'center' }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.lxHausysPrice > 0 ? item.lxHausysPrice.toLocaleString() : '0'}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.homeWindowPrice > 0 ? item.homeWindowPrice.toLocaleString() : '0'}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.kccHomeCCPrice > 0 ? item.kccHomeCCPrice.toLocaleString() : '0'}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.note || ''}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                  </tr>
                ));
              })()}
            </tbody>
          </table>
        </>
      )}

      {/* 중문 & 기타 섹션 */}
      {otherItems.length > 0 && (
        <>
          <div className="section-title section-title-main">중문 & 기타</div>
          <table className="table" id="otherTable">
            <tbody>
              <tr>
                <th className="col-1">NO</th>
                <th className="col-8">설치위치</th>
                <th className="col-19">품명</th>
                <th className="col-15">규격(W x H)</th>
                <th className="col-7">색상</th>
                <th className="col-5">수량</th>
                <th className="col-17">금액</th>
                <th className="col-12">비고</th>
              </tr>
              {otherItems.map((item: any, index: number) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <input
                      type="text"
                      value={item.installLocation || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.item || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.width && item.height ? `${item.width} x ${item.height}` : (item.spec || '-')}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.color || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.quantity || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.price ? parseFloat(item.price).toLocaleString() : '0'}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.note || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* 통바 섹션 */}
      {tongbaItems.length > 0 && (
        <>
          <div className="section-title section-title-main">통바</div>
          <table className="table" id="tongbaTable">
            <tbody>
              <tr>
                <th className="col-1">NO</th>
                <th className="col-28">품명</th>
                <th className="col-17">길이</th>
                <th className="col-13">수량</th>
                <th className="col-25">금액</th>
              </tr>
              {tongbaItems.map((item: any, index: number) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <input
                      type="text"
                      value={item.item || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.width || item.length || item.spec || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.quantity || ''}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.price ? parseFloat(item.price).toLocaleString() : '0'}
                      readOnly
                      className="bg-light-gray"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* 추가사항 섹션 */}
      {additionalItems.length > 0 && (
        <>
          <div className="section-title section-title-main">추가사항</div>
          <table className="table" id="additionalTable">
            <tbody>
              <tr>
                <th className="col-1">NO</th>
                <th className="col-30">품명</th>
                <th className="col-12">수량</th>
                <th className="col-28">금액</th>
              </tr>
              {additionalItems.map((item: any, index: number) => {
                // 직접입력 항목도 수량 곱하지 않고 price 그대로 사용
                let itemAmount = parseFloat(item.price) || 0;
                // if (item.item === '직접입력' || item.item === '직접입력(고객 비공개용)') {
                //   const quantity = parseFloat(item.quantity);
                //   if (quantity && !isNaN(quantity) && quantity > 0) {
                //     itemAmount = (parseFloat(item.price) || 0) * quantity;
                //   } else {
                //     itemAmount = 0;
                //   }
                // }

                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        type="text"
                        value={item.item || ''}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.quantity || ''}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={itemAmount.toLocaleString()}
                        readOnly
                        className="bg-light-gray"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}

      {/* 견적비고 */}
      {(() => {
        // 견적비고는 items의 첫 번째 항목에서 estimateNotes를 가져옴
        const estimateNotes = items?.[0]?.estimateNotes || '';
        if (!estimateNotes) return null;

        return (
          <div style={{ marginTop: '20px' }}>
            <div className="section-title section-title-main">견적비고</div>
            <textarea
              value={estimateNotes}
              readOnly
              className="bg-light-gray"
              style={{
                width: '100%',
                minHeight: '100px',
                resize: 'none',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px',
                lineHeight: '1.5'
              }}
            />
          </div>
        );
      })()}

      {/* 비고 */}
      {estimateData.specialNotes && (
        <div style={{ marginTop: '30px' }}>
          <div className="section-title">비고</div>
          <textarea
            value={estimateData.specialNotes}
            readOnly
            className="bg-light-gray"
            style={{
              width: '100%',
              minHeight: '100px',
              resize: 'none',
              padding: '10px',
              border: '1px solid #ddd'
            }}
          />
        </div>
      )}
    </div>
  );
};

export default EstimatePreviewReadOnly;